//#region imports
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { useNotificationHelper } from '../../../../../utilities/helpers/NotificationHelper';
import { CmsItem } from '../../../../../utilities/interfaces/CmsItem';
import { updateCmsItem } from '../../../../../features/public/publicCms-slice';
import { getAllPublicCms } from '../../../../../features/public/publicCms-slice';
import { CheckIfAdminUser } from '../../../../../utilities/helpers/AccountInfoHelper';
import { CmsItemType } from '../../../../../utilities/enums/CmsItemType';
//#endregion

export const useRulesCmsController = () => {
  //#region redux state
  const cmsValues: CmsItem[] = useAppSelector((state) => state.publicCms.cmsItems);
  const [infoCmsItem, setInfoCmsItem] = useState<any>();
  const [selectedCmsItem, setSelectedCmsItem] = useState<any>();
  const [editCmsOpen, setEditOpen] = useState<boolean>(false);
  const [cmsText, setCmsText] = useState<string>();
  const [cmsTitle, setCmsTitle] = useState<string | null>();
  const [isAdmin, setIsAdmin] = useState<boolean>(false);

  const dispatch = useAppDispatch();
  //#endregion

  //#region notification helper
  const { addNotification } = useNotificationHelper();

  // switches to the edit view
  const toggleCmsEdit = () => {
    editCmsOpen ? setEditOpen(false) : setEditOpen(true);
  };

  const handleCmsItemClick = (id: number) => {
    // get cmsItem text and title
    let cmsIndex = cmsValues.findIndex((cmsData) => cmsData.id === id);
    const cmsItem: CmsItem = cmsValues[cmsIndex];
    setSelectedCmsItem(cmsItem);
    setCmsText(cmsItem!.cmsItemValue);
    setCmsTitle(cmsItem!.cmsItemName);
    toggleCmsEdit();
  };

  const getAllCmsItems = () => {
    dispatch(getAllPublicCms());
  };

  const handleUploadResponseMessage = (message: string, type: 'error' | 'success') => {
    addNotification({
      type: type,
      message: message,
    });
  };

  const onSave = async (cmsItemText: string) => {
    let cmsItem = { ...selectedCmsItem, cmsItemValue: cmsItemText, cmsTypeId: CmsItemType.Html };
    dispatch(updateCmsItem(cmsItem))
      .unwrap()
      .then(() => {
        addNotification({
          type: 'success',
          message: `${cmsItem.cmsItemName} was saved successfully`,
        });
        toggleCmsEdit();
      })
      .catch((error: any) => {
        addNotification({
          type: 'error',
          message: `${cmsItem.cmsItemName} was unable to save. ${error.message}`,
        });
      });
  };

  useEffect(() => {
    // TODO: this will need to change when we get verbiage from NE and we'll need to add a new DB record for it
    if (cmsValues !== undefined && cmsValues.length > 0) {
      for (var i = 0; i < cmsValues.length; i++) {
        if (cmsValues[i].cmsItemName === 'Rules And Regulations Notice') {
          setInfoCmsItem(cmsValues[i]);
          let isAdminUser = CheckIfAdminUser();
          setIsAdmin(isAdminUser);
        }
      }
    }
  }, [cmsValues]);

  return {
    // functions
    onSave,
    toggleCmsEdit,
    handleCmsItemClick,
    handleUploadResponseMessage,
    getAllCmsItems,
    // getInfoCmsItem,
    //redux
    getAllPublicCms,
    dispatch,
    // state
    cmsValues,
    infoCmsItem,
    cmsText,
    cmsTitle,
    editCmsOpen,
    isAdmin,
  };
};
